module.exports = __webpack_public_path__ + "static/img/is_need_smt_2.5772481b.png";